import { Component, HostListener, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import {
    AddThreadTaskActionDTO,
    ArchiveTaskActionDTO,
    CreateKudosTaskActionDTO,
    CreatePollTaskActionDTO,
    KeepTaskActionDTO,
    MakePollRecurrentTaskActionDTO,
    ModerationTaskActionDTO,
    Task,
    TaskActionDTO,
    TaskAssignee,
    TaskListItem
} from "./taskbook.types";
import { UserService } from "@teammood/shared/util/user";
import { ITeam } from "@teammood/team";
import { TaskDialogService } from "./taskbook-dialog.service";
import { catchError, EMPTY, filter, Subject, takeUntil, tap } from "rxjs";
import { SnackBarService } from "@teammood/shared/ui/snack-bar";
import { LoggerService } from "@teammood/shared/util/logger";
import { MoodsService } from "../timeline/timeline-item/moods/moods.service";
import { Author, Thread, TimelineItemDialogService } from "@teammood/timeline";
import { FiltersService, FormatedSavedFilter } from "@teammood/filter";
import { DateRange } from "@angular/material/datepicker";
import { AnnouncementService } from "../shared/ui/announcement/announcement.service";
import { SavedFilterChange } from "../filter/saved-filter/saved-filter.component";
import { TranslateService } from "@ngx-translate/core";
import { UserInfos } from "../shared/ui/username-icon/user-infos.type";
import { ClosedOptions, PollTemplate, PollUnderCreation } from "../polls/create-poll/create-poll.type";
import { TaskbookService } from "./taskbook.service";
import { HeaderService } from "../header/header.service";
import { TaskBookBacklogDialogService } from "../taskbook-backlog/taskbook-backlog-dialog.service";
import { Router } from "@angular/router";
import { CreatePollService } from "../polls/create-poll/create-poll.service";


@Component({
    selector: 'taskbook-triage',
    templateUrl: './taskbook-triage.component.html',
    styleUrls: ['./taskbook-triage.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TaskbookTriageComponent implements OnInit, OnDestroy {

    userId: string;
    userInfos: UserInfos;
    author: Author;
    currentTask: Task;
    numberOfCurrentTask: number = 1;
    numberOfRemainingTasks: number = 0;
    numberOfTasks: number;
    taskProgressionValue: number;
    teams: ITeam[]
    scrollTaskbookContent: boolean;
    showAnnouncement: boolean = false;
    managers: TaskAssignee[];
    //saved-filter data
    pageTitle = '';
    showSpinner = true;
    dateInterval: DateRange<Date>;
    selectedFilter: FormatedSavedFilter;
    threadInCreation: boolean = false;
    hasMoreItemsInOtherTeams: boolean = false;
    allTeamsFilter: FormatedSavedFilter;

    private _destroy$ = new Subject<void>();

    @HostListener('window:scroll', ['$event']) getScrollHeight(event) {
        const pageYOffset = this.showAnnouncement ? 400 : 290;
        this.scrollTaskbookContent =  window.pageYOffset > pageYOffset;
     }

    constructor(
        private taskbookService: TaskbookService,
        private userService: UserService,
        private taskDialogService: TaskDialogService,
        private snackBarService: SnackBarService,
        private logger: LoggerService,
        private moodsService: MoodsService,
        private timelineItemDialogService: TimelineItemDialogService,
        private announcementService: AnnouncementService,
        private translate: TranslateService,
        private headerService: HeaderService,
        private filtersService: FiltersService,
        private taskbookBacklogDialogService: TaskBookBacklogDialogService,
        private router: Router,
        private createPollService: CreatePollService
    ){}

    async ngOnInit() {
        this.userService.get().then(async (user) => {
            if (user) {
                this.showAnnouncement = this.announcementService.showForUserFunction(user);
                this.userInfos = new UserInfos(user.firstname, user.lastname);
                this.teams = [...user.teams];
                this.author = {id: user.id, fullname: user.fullname};
            }
        });

        this.headerService.getTriageCount().pipe(
            tap(count => {
                this.hasMoreItemsInOtherTeams = count > 0;
                if (this.numberOfRemainingTasks == 0){
                    this.filtersService.loadFilters(true).then(filters => {
                        const allTeamsFilter = this.filtersService.formatFilters(filters).find(filter => filter.id === 'all_teams')
                        if (allTeamsFilter) {
                            this.allTeamsFilter = allTeamsFilter;
                        }
                    });
                }
            }),
            takeUntil(this._destroy$)
        )
        .subscribe();

    }

    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }

    loadTaskbook(filter: SavedFilterChange = null){
        this.taskbookService.triage(filter).pipe(
            tap(async (task: Task) => {
                this.currentTask = task;
                this.showSpinner = false;
                this.managers = task.availableAssignees;
            }),
            takeUntil(this._destroy$)
        ).subscribe();

        this.taskbookService.triageInfos(filter).pipe(
            tap(count => {
                this.numberOfTasks = count.count;
                this.updateTaskNumbers(count.count);
                this.headerService.setTriageCount(count.count);
            }),
            takeUntil(this._destroy$)
        ).subscribe();
    }

    loadAllTeamsFilter(){
        if (this.allTeamsFilter) {
            this.onFilterChange({
                dateInterval: this.dateInterval,
                filter: this.allTeamsFilter
            });
        }
    }

    onFilterChange(filter: SavedFilterChange){
        this.selectedFilter = filter.filter;
        this.numberOfCurrentTask = 1;
        this.loadTaskbook(filter);
    }

    protected onAction(data: {task: Task, actionId: string}){
        switch(data.actionId) {
            case 'archive': 
                this.triageAction(new ArchiveTaskActionDTO(data.task.id, data.task.itemType, this.selectedFilter.decodedFilter));
                break;
            case 'keep':
                this.triageAction(new KeepTaskActionDTO(data.task.id, data.task, this.selectedFilter.decodedFilter));
                break;
            case 'thread': 
                this.threadInCreation = true; 
                break;
            // case 'kudos': 
            //     this.kudos(data.task);
            //     break;
            // case 'poll': 
            //     this.poll(data.task);
            //     break;
            // case 'makePollrecurrent':
            //     this.makePollRecurrent(data.task)
            //     break;
        }
    }

    onThreadCreation(data: {threadContent: Thread}){
        if(data?.threadContent){
            const action = new AddThreadTaskActionDTO(this.currentTask.id, this.currentTask.itemType, this.selectedFilter.decodedFilter, data.threadContent.message, data.threadContent.isAnonymous);
            this.triageAction(action);
        }
        this.threadInCreation = false; 
    }

    protected async triageAction(action: TaskActionDTO){
        this.taskbookService.triageAction(action).pipe(
            tap(async (task: Task) => {
                // if(action.taskActionContent.id !== 'addThread') // todo different behavior for addThread ?
                this.currentTask = task;
                this.snackBarService.success('task_success.title');
                this.numberOfCurrentTask++;
                this.updateTaskNumbers(this.numberOfRemainingTasks - 1);
                if(task.error){
                    const emptyTaskbookDialogRef = await this.taskbookBacklogDialogService.openEmptyTaskbookBacklogDialog(this.selectedFilter, this.hasMoreItemsInOtherTeams);
                    emptyTaskbookDialogRef.beforeClosed().pipe(
                        tap(data => {
                            if (data.redirect){
                                if(data.hasMoreItemsInOtherTeams){
                                    this.loadAllTeamsFilter();
                                }else{
                                    this.router.navigate(['/backlog']);
                                }
                            } 
                        }),
                        takeUntil(emptyTaskbookDialogRef.afterClosed())
                    ).subscribe();
                    
                }
            }),
            catchError(error => {
                this.logger.error('Error saving action:', error?.text);
                this.snackBarService.error('Oops')
                return EMPTY;
            }),
            takeUntil(this._destroy$)
        ).subscribe();
    }

    async openModerationDialog(task){
        const dialogRef = await this.timelineItemDialogService.moderate();
        dialogRef.beforeClosed().pipe(
            filter(why => !!why),
            tap((why: string) => {
                const action = new ModerationTaskActionDTO(task.id, task.itemType, this.selectedFilter.decodedFilter, why);
                this.triageAction(action);
                this.snackBarService.success('moderation_success');
            }),
            takeUntil(dialogRef.afterClosed())
          ).subscribe();
    }

    protected async poll(){
        const pollTemplates = []; // from scratch
        const pollDialogRef = await this.timelineItemDialogService.createPoll(this.teams, pollTemplates, '');

        pollDialogRef.beforeClosed().pipe(
            filter((poll) => !!poll),
            tap(async poll => {
                await this.addPoll(poll);
            }),
            takeUntil(pollDialogRef.afterClosed())
        ).subscribe();
    }

    private async addPoll(poll: PollUnderCreation) {
        await this.createPollService.createPoll(poll);
        if(poll._serializePoll){
            this.poll();
        }
        this.snackBarService.success(this.translate.instant('question_created'));
    } 

    // protected async poll(task?: Task){
    //     const pollTemplates: PollTemplate[] = task ? [
    //         {
    //             id: task.id,
    //             label: this.translate.instant('task_action.poll.template'),
    //             answerOptions: new ClosedOptions([
    //                 {
    //                     label: this.translate.instant('Yes')
    //                 },
    //                 {
    //                     label: this.translate.instant('No')
    //                 }
    //             ])
    //         }
    //     ]: [];
        
    //     const pollDialogRef = await this.timelineItemDialogService.createPoll(this.teams, pollTemplates, '');
        
    //     pollDialogRef.beforeClosed().pipe(
    //         filter((poll) => !!poll),
    //         tap(async (poll: PollUnderCreation) => {
    //             // when the taskbook is empty, no task
    //             const action = new CreatePollTaskActionDTO(task.id, task.itemType, this.selectedFilter.decodedFilter, poll);
    //             this.triageAction(action);
    //         }),
    //         takeUntil(pollDialogRef.afterClosed())
    //     ).subscribe();
    // }

    protected async makePollRecurrent(task: Task) {
        const dialogRef = await this.taskDialogService.makePollRecurrent(task);
        dialogRef.beforeClosed().pipe(
            filter(task => !!task),
            tap(task => {
                if (task.recurrence?.frequency && task.recurrence?.duration) {
                    const action = new MakePollRecurrentTaskActionDTO(task.id, task.itemType, this.selectedFilter.decodedFilter, task.recurrence, task.pollTargets.map(t => t.id));
                    this.triageAction(action);
                }
            }),
            takeUntil(dialogRef.afterClosed())
        ).subscribe();
    }

    protected async kudos(task?: Task) {
        const dialogRef = await this.timelineItemDialogService.createKudos(this.teams, this.author);
        dialogRef.beforeClosed().pipe(
            filter((kudos) => !!kudos),
            tap(kudos => {
                if (kudos.message?.body) {
                    kudos.message.body = this.moodsService.addSpaceBeforeLink(kudos.message.body);
                    const action = new CreateKudosTaskActionDTO(task.id, task.itemType, this.selectedFilter.decodedFilter, kudos, kudos.teamId);
                    this.triageAction(action);
                }
            }),
            takeUntil(dialogRef.afterClosed())
        ).subscribe();
    }


    protected updateTaskNumbers(count: number){
        // progression of the session
        this.numberOfRemainingTasks = count;
        this.taskProgressionValue = this.numberOfRemainingTasks === 0 ? 100 : (this.numberOfCurrentTask - 1) / this.numberOfTasks * 100;
    }
}